import type { GridFilterItem } from '@packages/fenrir/components/datagrid';
import {
  GridDateOperator,
  GridNumericOperator,
  GridSelectOperator,
  GridStringOperator,
} from '@packages/fenrir/components/datagrid';

import { ASSET_COLUMNS_DEFS } from '../../../components/assets-table/asset-table.constants';
import type { AssetType } from '../../asset-type';

export const ASSET_FIELD_FILTERS = [
  'categories',
  'importances',
  'lastScan',
  'lastSeen',
  'riskScore',
  'sources',
  'tags',
  'name',
  'hostname',
  'os',
  'mac',
  'ipAddress',
] as const;

export type AssetFieldFilter = (typeof ASSET_FIELD_FILTERS)[number];

export const isAssetFieldFilter = (value: unknown): value is AssetFieldFilter =>
  ASSET_FIELD_FILTERS.includes(value as AssetFieldFilter);

export const fieldFilterLocaleKeys: Record<AssetFieldFilter, string> = {
  categories: 'ads:fields.category',
  importances: 'ads:fields.importance',
  lastScan: 'ads:fields.lastSuccessfulScan',
  lastSeen: 'ads:fields.lastSeen',
  riskScore: 'ads:fields.riskScore',
  tags: 'ads:fields.tags',
  sources: 'ads:fields.sources',
  name: 'ads:fields.name',
  hostname: 'ads:fields.hostname',
  os: 'ads:fields.os',
  mac: 'ads:fields.macAddress',
  ipAddress: 'ads:fields.ipAddress',
} as const;

// TODO: Exploring the approach of having dynamic form controlled by url params
export const availableFiltersByType: Record<AssetType, AssetFieldFilter[]> = {
  data: [],
  devices: [
    'name',
    'categories',
    'tags',
    'sources',
    'riskScore',
    'importances',
    'lastScan',
    'lastSeen',
    'ipAddress',
    'mac',
    'hostname',
    'os',
  ],
  network: [],
  users: [],
};

/*
 * Default filters for each asset type
 * These filters are used to initialize the custom filter component
 */
export const defaultFiltersByType: Record<AssetType, AssetFieldFilter[]> = {
  data: [],
  devices: [
    'name',
    'tags',
    'categories',
    'sources',
    'riskScore',
    'lastSeen',
    'lastScan',
  ],
  network: [],
  users: [],
};

/*
 * Default filters for each asset type
 * These filters are used to initialize the data grid filters
 */
export const defaultGridFiltersByType: Record<AssetType, GridFilterItem[]> = {
  data: [],
  devices: [
    {
      id: 1,
      field: ASSET_COLUMNS_DEFS.NAME,
      operator: GridStringOperator.Contains,
      value: undefined,
    },
    {
      id: 2,
      field: ASSET_COLUMNS_DEFS.TAGS,
      operator: GridSelectOperator.isAnyOf,
      value: undefined,
    },
    {
      id: 3,
      field: ASSET_COLUMNS_DEFS.CATEGORY,
      operator: GridSelectOperator.isAnyOf,
      value: undefined,
    },
    {
      id: 4,
      field: ASSET_COLUMNS_DEFS.SOURCES,
      operator: GridSelectOperator.isAnyOf,
      value: undefined,
    },
    {
      id: 5,
      field: ASSET_COLUMNS_DEFS.RISK_SCORE,
      operator: GridNumericOperator.isBetween,
      value: undefined,
    },
    {
      id: 6,
      field: ASSET_COLUMNS_DEFS.LAST_SEEN_TIME,
      operator: GridDateOperator.isBetween,
      value: undefined,
    },
    {
      id: 7,
      field: ASSET_COLUMNS_DEFS.LAST_SUCCESSFUL_SCANNED,
      operator: GridDateOperator.isBetween,
      value: undefined,
    },
  ],
  network: [],
  users: [],
};
